import React from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import useConvertTiffToPng from '@/utils/hooks/useConvertTiffToPng';

import { ImgSquare } from '../ScanPreview.styles';

interface Props {
  url?: string;
  alt?: string;
}

const TiffThumb: React.FC<Props> = ({ url, alt }) => {
  const { pngDocuments, isLoading } = useConvertTiffToPng({ url });
  const firstImage = pngDocuments?.[0];

  if (isLoading) {
    return (
      <Box height="60px" justify="center" align="center">
        <Preloader testId="tiff-thumb-preloader" />
      </Box>
    );
  }

  return (
    <ImgSquare src={firstImage?.link} alt={alt} />
  );
};

export default TiffThumb;

